const UrlLive = 'https://rsgrahahermine.id'
const UrlDev = 'https://127.0.0.1/grahahermine'
const Url = UrlLive

//const namesOfModes = ['dark', 'moonlight', 'eclipse', 'light']

export { Url }